module.exports = __webpack_public_path__ + "static/media/all_order.3193bb2a.svg";